/* /cart qty-stepper UX -- core webshop's own bind_change_qty/
   bind_remove_cart_item (webshop/templates/pages/cart.js) route every
   single +/-, typed-qty, or remove-item interaction through
   shopping_cart.shopping_cart_update, which unconditionally:
     1. calls shopping_cart.freeze() -- a full-viewport dark
        .modal-backdrop over the ENTIRE page, before the request even
        starts.
     2. on response, does $(".cart-items").html(r.message.items) -- tears
        down and rebuilds every row in the table, not just the one that
        changed.
   Neither is a real navigation, but together they read as one: a
   page-wide dim flash then every row (images, inputs, focus) rebuilt, on
   every single tap. For an ordersheet rep tapping +/- repeatedly across
   many rows that's the actual complaint ("every little change refreshes
   the page").

   This file leaves core's handlers and shopping_cart_update completely
   alone (other flows -- notes edits, Place Order, Request Quotation --
   still use them as-is) and instead rebinds ONLY the three qty-affecting
   interactions (stepper buttons, typed qty, remove) to call
   shopping_cart.update_cart directly with a row-scoped callback: patch
   just the one <tr> that changed (or remove it, if qty went to 0) plus
   the small totals/tax blocks, and suppress freeze()'s page-wide overlay
   for just these calls. cart_resilience.js's own wrapping of
   shopping_cart.update_cart (offline queueing, conflict handling) is
   untouched and still applies underneath this. */
(function () {
	if (!window.webshop || !webshop.webshop || !webshop.webshop.shopping_cart) {
		return;
	}
	if (!window.location.pathname || !window.location.pathname.startsWith("/cart")) {
		return;
	}

	var shopping_cart = webshop.webshop.shopping_cart;
	var BUSY_CLASS = "rfhq-qty-busy";

	/* suppressFreeze is a counter, not a boolean -- two rows can have an
	   in-flight request at once (rapid taps across different rows), and a
	   boolean would let the first call's callback clear the flag while the
	   second call is still pending, letting freeze()'s overlay flash back
	   on mid-interaction. */
	var suppressFreeze = 0;
	var original_freeze = shopping_cart.freeze;
	var original_unfreeze = shopping_cart.unfreeze;

	if (typeof original_freeze === "function") {
		shopping_cart.freeze = function () {
			if (suppressFreeze > 0) return;
			return original_freeze.apply(this, arguments);
		};
	}
	if (typeof original_unfreeze === "function") {
		shopping_cart.unfreeze = function () {
			if (suppressFreeze > 0) return;
			return original_unfreeze.apply(this, arguments);
		};
	}

	function findLiveRow(item_code) {
		return $(".cart-items")
			.find('.cart-qty[data-item-code="' + item_code + '"]')
			.closest("tr");
	}

	/* message.items is core's cart_items.html output -- bare <tr> siblings
	   meant to sit directly inside the .cart-items <tbody> (see
	   cart.html), not a standalone fragment -- wrapping in a real
	   <table><tbody> before handing it to jQuery is what makes the <tr>s
	   parse as actual table rows instead of being silently dropped. */
	function applyServerResponse(item_code, message) {
		if (message && message.items !== undefined) {
			var $fresh = $("<table><tbody>" + message.items + "</tbody></table>");
			var $freshRow = $fresh
				.find('.cart-qty[data-item-code="' + item_code + '"]')
				.closest("tr");
			var $liveRow = findLiveRow(item_code);

			if (!$freshRow.length) {
				// qty went to 0 -- item was actually removed server-side.
				if ($liveRow.length) {
					$liveRow.fadeOut(150, function () {
						$(this).remove();
					});
				}
			} else if ($liveRow.length) {
				$liveRow.replaceWith($freshRow);
			}
		}

		if (message && message.total !== undefined) {
			$(".cart-tax-items").html(message.total);
		}
		if (message && message.taxes_and_totals !== undefined) {
			$(".payment-summary").html(message.taxes_and_totals);
		}
		shopping_cart.set_cart_count();
	}

	/* All qty/remove requests share ONE Quotation document (the cart) --
	   core's own freeze() used to (as an unintended side effect of dimming
	   the whole page) serialize every mutation globally, since the overlay
	   blocked tapping a SECOND row's stepper until the first row's request
	   had finished. This file's busy-lock is per-row, not global, so
	   without an explicit queue here, tapping two different rows quickly
	   fires two genuinely concurrent update_cart calls against the same
	   document -- both load it, then race to save it, and the loser hits
	   Frappe's own optimistic-locking check (TimestampMismatchError:
	   "Document has been modified after you have opened it"), surfaced as
	   a full server-exception page. requestChain forces every call through
	   in submission order, one at a time, so the cart doc is never loaded
	   by a second save before the first one's save has landed -- rows can
	   still show busy/queue up instantly, they just aren't sent
	   concurrently underneath. */
	var requestChain = Promise.resolve();

	function submitQtyChange(item_code, qty, additional_notes) {
		var $row = findLiveRow(item_code);
		if ($row.hasClass(BUSY_CLASS)) return;
		$row.addClass(BUSY_CLASS);

		requestChain = requestChain.then(function () {
			return new Promise(function (resolve) {
				suppressFreeze++;
				shopping_cart.update_cart({
					item_code: item_code,
					qty: qty,
					additional_notes: additional_notes,
					with_items: 1,
					callback: function (r) {
						suppressFreeze = Math.max(0, suppressFreeze - 1);
						// Row may already be gone (fast repeat taps) --
						// re-select rather than reuse the stale $row
						// reference.
						findLiveRow(item_code).removeClass(BUSY_CLASS);

						if (!r || r.exc) {
							// Rare (validation/stock/conflict error) -- a
							// full reload is the safe way back to a
							// known-correct state, same fallback
							// cart_resilience.js already uses for real
							// conflicts.
							window.location.reload();
							resolve();
							return;
						}
						applyServerResponse(item_code, r.message);
						resolve();
					},
				});
			});
		});
	}

	function handleStepperClick(e) {
		var $btn = $(this);
		var $wrapper = $btn.closest(".number-spinner");
		var $input = $wrapper.find(".cart-qty");
		var $row = $input.closest("tr");
		if ($row.hasClass(BUSY_CLASS)) return;

		var oldValue = parseInt($input.val(), 10) || 0;
		var newVal = 0;

		if ($btn.attr("data-dir") === "up") {
			newVal = oldValue + 1;
		} else if (oldValue > 1) {
			newVal = oldValue - 1;
		}
		// else: decrementing at qty 1 -- newVal stays 0, matching core's
		// existing behaviour of removing the item (see webshop's own
		// bind_change_qty), just via the row-scoped path instead of a
		// full-table nuke.

		$input.val(newVal);
		var item_code = $input.attr("data-item-code");
		var notes = $row.find(".notes textarea").val() || "";
		submitQtyChange(item_code, newVal, notes);
	}

	function handleQtyInputChange() {
		var $input = $(this);
		var $row = $input.closest("tr");
		if ($row.hasClass(BUSY_CLASS)) return;

		var newVal = parseInt($input.val(), 10);
		if (isNaN(newVal) || newVal < 0) return;

		var item_code = $input.attr("data-item-code");
		var notes = $row.find(".notes textarea").val() || "";
		submitQtyChange(item_code, newVal, notes);
	}

	function handleRemoveClick(e) {
		var $btn = $(e.currentTarget);
		var item_code = $btn.data("item-code");
		if (!item_code) return;
		var $row = findLiveRow(item_code);
		if ($row.hasClass(BUSY_CLASS)) return;

		submitQtyChange(item_code, 0);
	}

	/* Deferred one tick past frappe.ready: core's own cart.js registers
	   its frappe.ready(bind_events) the same way this file does, and
	   frappe.ready callbacks fire in registration order regardless of
	   which <script> tag queued them -- there's no reliable way to know
	   from here whether core's callback already ran by the time this
	   one does. setTimeout(fn, 0) pushes the unbind/rebind to the next
	   tick, after every frappe.ready callback queued for this cycle
	   (core's bind_events included) has already executed, so there's
	   always something bound to remove before we replace it. */
	frappe.ready(function () {
		setTimeout(function () {
			var $cartItems = $(".cart-items");
			if (!$cartItems.length) return;

			$cartItems.off("click", ".number-spinner button");
			$cartItems.off("change", ".cart-qty");
			$(".cart-items").off("click", ".remove-cart-item");

			$cartItems.on("click", ".number-spinner button", handleStepperClick);
			$cartItems.on("change", ".cart-qty", handleQtyInputChange);
			$cartItems.on("click", ".remove-cart-item", handleRemoveClick);
		}, 0);
	});
})();
